import urlParser from 'url'

export function uriParser(uri) {
  const parsedUrl = urlParser.parse(uri, true)

  return {
    protocol: parsedUrl.protocol ? parsedUrl.protocol.substring(0, parsedUrl.protocol.length - 1) : null,
    host: parsedUrl.hostname,
    path: parsedUrl.pathname ? parsedUrl.pathname.substring(1, parsedUrl.pathname.length) : null,
  }
}

export function detect(uri: string): string | null {
  const uriParts = uriParser(uri)

  for (const socialNetworkLabel in socialNetworkPatterns) {
    if (!Object.prototype.hasOwnProperty.call(socialNetworkPatterns, socialNetworkLabel)) {
      continue
    }

    for (const searchRegexp of socialNetworkPatterns[socialNetworkLabel]) {
      if (searchRegexp.test(uriParts.host)) {
        return socialNetworkLabel
      }
    }
  }

  return null
}

export function getNetworksList(): string[] {
  return Object.keys(socialNetworkPatterns)
}

const socialNetworkPatterns = {
  anchor: [
    /anchor\.fm$/,
  ],
  angellist: [
    /angel\.co$/,
  ],
  behance: [
    /behance\.net$/,
  ],
  clubhouse: [
    /joinclubhouse\.com$/,
    /clubber\.one$/,
  ],
  devdotto: [
    /dev\.to$/,
  ],
  discord: [
    /discord\.com$/,
    /discord\.gg$/,
    /discordapp\.com$/,
    /discord\.com$/,
    /discord\.gg$/,
    /discord\.media$/,
    /discordapp\.com$/,
    /discordapp\.net$/,
    /discordstatus\.com$/,
    /com\.discord$/,
  ],
  dribbble: [
    /dribbble\.com$/,
  ],
  facebook: [
    /facebook\.com$/,
    /fbcdn\.net$/,
    /tfbnw\.net$/,
    /messenger\.com$/,
    /m\.me$/,
    /fb\.com$/,
    /fbcdn\.com$/,
    /facebook\.net$/,
    /fbsbx\.com$/,
    /fbsbx\.com\.online-metrix\.net$/,
    /fbcdn-profile-a\.akamaihd\.net$/,
    /fb\.me$/,
    /facebook-web-clients\.appspot\.com$/,
    /connect\.facebook\.net\.edgekey\.net$/,
    /profile\.ak\.facebook\.com\.edgesuite\.net$/,
    /as63293\.net$/,
    /as63293\.org$/,
    /as63293\.com$/,
    /atdmt-host\.com$/,
    /atdmt-ppe\.com$/,
    /atdmt2\.com$/,
    /advancediddetection\.com$/,
    /afcbook\.com$/,
    /afcebook\.co$/,
    /afcecbook\.com$/,
    /album-in-your-hand\.com$/,
    /alotmorefans\.com$/,
    /alotoffans\.com$/,
    /thefacebook\.com$/,
    /friendfeed\.com$/,
    /thefind\.com$/,
    /facebookstories\.com$/,
    /acebok\.com$/,
    /acebooik\.com$/,
    /acebook\.de$/,
    /acebook\.cl$/,
    /acebook\.com$/,
    /acebookfans\.com$/,
    /acebookfriends\.com$/,
    /acfebook\.com$/,
    /dacecbook\.com$/,
    /de-defacebook\.com$/,
    /m\.facebook\.com$/,
    /com\.facebook\.lite$/,
  ],
  github: [
    /github\.com$/,
    /gitlab\.com$/,
  ],
  instagram: [
    /com\.instagram\.android$/,
    /instagram\.com$/,
    /instagram\.com$/,
    /cdninstagram\.com$/,
    /instagram\.c10r\.facebook\.com$/,
    /instagramstatic-a\.akamaihd\.net$/,
    /instagram-shv-01-ams2\.fbcdn\.net$/,
    /instagram-shv-01-ams3\.fbcdn\.net$/,
    /instagram-shv-01-ash5\.fbcdn\.net$/,
    /instagram-shv-01-atl1\.fbcdn\.net$/,
    /instagram-shv-01-bru2\.fbcdn\.net$/,
    /instagram-shv-01-cai1\.fbcdn\.net$/,
    /instagram-shv-01-cdg2\.fbcdn\.net$/,
    /instagram-shv-01-dfw1\.fbcdn\.net$/,
    /instagram-shv-01-fra3\.fbcdn\.net$/,
    /instagram-shv-01-gru1\.fbcdn\.net$/,
    /instagram-shv-01-hkg2\.fbcdn\.net$/,
    /instagram-shv-01-iad3\.fbcdn\.net$/,
    /instagram-shv-01-kul1\.fbcdn\.net$/,
    /instagram-shv-01-lax1\.fbcdn\.net$/,
    /instagram-shv-01-lga1\.fbcdn\.net$/,
    /instagram-shv-01-lhr3\.fbcdn\.net$/,
    /instagram-shv-01-mad1\.fbcdn\.net$/,
    /instagram-shv-01-mia1\.fbcdn\.net$/,
    /instagram-shv-01-mxp1\.fbcdn\.net$/,
    /instagram-shv-01-nrt1\.fbcdn\.net$/,
    /instagram-shv-01-ord1\.fbcdn\.net$/,
    /instagram-shv-01-sea1\.fbcdn\.net$/,
    /instagram-shv-01-sin1\.fbcdn\.net$/,
    /instagram-shv-01-sjc2\.fbcdn\.net$/,
    /instagram-shv-01-syd1\.fbcdn\.net$/,
    /instagram-shv-01-tpe1\.fbcdn\.net$/,
    /instagram-shv-01-vie1\.fbcdn\.net$/,
    /instagram-shv-02-cai1\.fbcdn\.net$/,
    /instagram-shv-02-hkg2\.fbcdn\.net$/,
    /instagram-shv-03-ash5\.fbcdn\.net$/,
    /instagram-shv-03-atn1\.fbcdn\.net$/,
    /instagram-shv-03-hkg1\.fbcdn\.net$/,
    /instagram-shv-03-lla1\.fbcdn\.net$/,
    /instagram-shv-03-prn2\.fbcdn\.net$/,
    /instagram-shv-03-xdc1\.fbcdn\.net$/,
    /instagram-shv-04-hkg1\.fbcdn\.net$/,
    /instagram-shv-06-atn1\.fbcdn\.net$/,
    /instagram-shv-06-lla1\.fbcdn\.net$/,
    /instagram-shv-07-ash4\.fbcdn\.net$/,
    /instagram-shv-07-frc3\.fbcdn\.net$/,
    /instagram-shv-09-frc1\.fbcdn\.net$/,
    /instagram-shv-09-lla1\.fbcdn\.net$/,
    /instagram-shv-12-frc1\.fbcdn\.net$/,
    /instagram-shv-12-frc3\.fbcdn\.net$/,
    /instagram-shv-12-lla1\.fbcdn\.net$/,
    /instagram-shv-12-prn1\.fbcdn\.net$/,
    /instagram-shv-13-frc1\.fbcdn\.net$/,
    /instagram-shv-17-prn1\.fbcdn\.net$/,
    /instagram-shv-18-prn1\.fbcdn\.net$/,
  ],
  linkedin: [
    /linkedin\.cn$/,
    /linkedin\.com\.ni$/,
    /linkedin\.co\.nz$/,
    /linkedin\.com\.ar$/,
    /linkedin\.com\.hk$/,
    /linkedin\.com\.au$/,
    /linkedin\.co\.id$/,
    /linkedin\.com\.br$/,
    /linkedin\.net$/,
    /linkedin\.page$/,
    /linkedin\.com\.gt$/,
    /linkedin\.com\.mx$/,
    /linkedin\.co\.uk$/,
    /linkedin\.com$/,
    /linkedin\.com\.sv$/,
    /linkedin\.com\.py$/,
    /linkedin\.co\.th$/,
    /linkedin\.com\.pk$/,
    /linkedin-a\.com$/,
    /linkedin-alpha\.com$/,
    /linkedin-delta\.com$/,
    /linkedin-ei\.cn$/,
    /linkedin-ei2\.com$/,
    /linkedin-epsilon\.com$/,
    /linkedin-esv4\.com$/,
    /linkedln\.com$/,
    /linkedin-gamma\.com$/,
    /linkedin-inc\.com$/,
    /linkedin-prime\.com$/,
    /linkedin-zeta\.com$/,
    /linkedincorporation\.com$/,
    /linkedinelearning\.com$/,
    /linkedinexpert\.nl$/,
    /linkedinresearch\.com$/,
    /linkedln\.com$/,
    /linqedin\.nl$/,
    /linnkedin\.com$/,
    /lnkd\.in$/,
    /lnkd-ei\.in$/,
    /linkedin\.biz$/,
    /linkdin\.com$/,
    /linkd\.in$/,
    /com\.linkedin\.android$/,
    /linkedin\.android$/,
  ],
  medium: [
    /com\.medium\.reader$/,
    /com\.medium$/,
  ],
  onlyfans: [
    /onlyfans\.com$/,
  ],
  pinterest: [
    /com\.pinterest$/,
    /com\.pinterest\.twa$/,
    /pinttest\.com$/,
    /pinimg\.com$/,
    /pinterest\.de$/,
    /pinterest\.se$/,
    /pinterest\.pt$/,
    /pinterest\.at$/,
    /pinterest\.dk$/,
    /as53620\.net$/,
    /pin\.it$/,
    /pinterest\.co\.at$/,
    /pinterest\.com\.au$/,
    /pinterest\.hu$/,
    /pinterest\.be$/,
    /pinterest\.co\.kr$/,
    /pinterest\.ca$/,
    /pinterest\.com\.bo$/,
    /pinterest\.com$/,
    /pinterest\.in$/,
    /pinterest\.com\.ec$/,
    /pinterest\.ec$/,
    /pinterest\.com\.py$/,
    /pinterest\.co$/,
    /pinterest\.co\.uk$/,
    /pinterest\.kr$/,
    /pinterest\.ru$/,
    /pinterest\.id$/,
    /pinterest\.nz$/,
    /pinterest\.uk$/,
    /pinterest\.it$/,
    /pinterest\.co\.in$/,
    /pinterest\.info$/,
    /pinterest\.nl$/,
    /pinterest\.ch$/,
    /pinterest\.pe$/,
    /pinterest\.th$/,
    /pinterest\.jp$/,
    /pinterest\.ie$/,
    /pinterest\.com\.mx$/,
    /pinterest\.cl$/,
  ],
  producthunt: [
    /producthunt\.com$/,
  ],
  qq: [
    /qq\.com$/,
    /myqcloud\.com$/,
    /qcloud\.com$/,
    /tencent-cloud\.com$/,
    /com\.tencent\.mobileqq$/,
    /com\.tencent\.androidqqmail$/,
    /gkqq\.fh$/,
    /imqq\.cn/,
  ],
  quora: [
    /quora\.com$/,
    /com\.quora\.android$/,
  ],
  reddit: [
    /reddit\.com$/,
    /redd\.it$/,
    /redditgifts\.com$/,
    /redditinc\.com$/,
    /redditmedia\.com$/,
    /redditstatic\.com$/,
    /reddituploads\.com$/,
    /com\.reddit\.frontpage$/,
  ],
  slack: [
    /com\.slack$/,
    /com\.Slack$/,
    /slack-redir\.net$/,
  ],
  snapchat: [
    /com\.snapchat\.android$/,
    /snapchat\.com$/,
  ],
  spotify: [
    /spotify\.com$/,
  ],
  substack: [
    /substack\.com$/,
  ],
  telegram: [
    /org\.telegram\.messenger$/,
    /org\.telegram\.messenger\.web$/,
    /org\.telegram\.messenger\.beta$/,
    /org\.telegram\.messenger\.revamp$/,
    /t\.me$/,
    /telegram\.me$/,
    /telegram\.org$/,
  ],
  tiktok: [
    /tiktok\.com$/,
    /tiktokv\.com$/,
    /tiktokcdn\.com$/,
    /musical\.ly$/,
    /com\.zhiliaoapp\.musically$/,
    /com\.zhiliao\.musically\.livewallpaper$/,
    /douyin\.com$/,
    /com\.yaozu\.wallpaper$/,
    /com\.yaozu\.tiktokwallpaper$/,
  ],
  tumblr: [
    /tumblr\.com$/,
    /t\.umblr\.com$/,
    /umblr\.com$/,
    /tmblr\.co$/,
    /tumblr\.net$/,
    /tumblr\.co$/,
    /tumblrhq\.com$/,
    /tumblrmusic\.com$/,
    /tumblrstream\.com$/,
    /tumblr\.net$/,
    /com\.tumblr$/,
  ],
  x: [
    /twitter\.com$/,
    /twimg\.com$/,
    /twiimg\.com$/,
    /tweetdeck\.twitter\.com$/,
    /tweetdeck\.co\.uk$/,
    /tweetdeck\.com$/,
    /tweetnetwork\.com$/,
    /tweetsdeck\.com$/,
    /twitter\.rs$/,
    /twitter\.hk$/,
    /twitter\.tj$/,
    /twitter\.pt$/,
    /twitter\.eus$/,
    /twitter\.ae$/,
    /twitter\.com\.tr$/,
    /twitter\.uz$/,
    /twitter\.co\.uk$/,
    /twitter\.sk$/,
    /twitter\.org$/,
    /twitter\.ie$/,
    /twitter\.ch$/,
    /twitter\.fr$/,
    /twitter\.com\.br$/,
    /twitter\.jp$/,
    /twittr\.com$/,
    /twittter\.com$/,
    /t\.co$/,
    /com\.twitter\.android$/,
    /com\.twitter\.android\.lite$/,
    /x\.com$/,
    /x\.rs$/,
    /x\.hk$/,
    /x\.tj$/,
    /x\.pt$/,
    /x\.eus$/,
    /x\.ae$/,
    /x\.com\.tr$/,
    /x\.uz$/,
    /x\.co\.uk$/,
    /x\.sk$/,
    /x\.org$/,
    /x\.ie$/,
    /x\.ch$/,
    /x\.fr$/,
    /x\.com\.br$/,
    /x\.jp$/,
    /x\.com$/,
    /x\.com$/,
    /z\.co$/,
    /com\.x\.android$/,
    /com\.x\.android\.lite$/,
  ],
  twitch: [
    /twitch\.tv$/,
    /jtvnw\.net$/,
    /ttvnw\.net$/,
    /tv\.twitch\.android\.app$/,
  ],
  vkontakte: [
    /vk\.com$/,
    /vk-cdn\.me$/,
    /vk-cdn\.net$/,
    /vkontakte\.com$/,
    /mvk\.com$/,
    /vk\.life$/,
    /vkadre\.ru$/,
    /vk-portal\.org$/,
    /vk-portal\.net$/,
    /vkmessenger\.com$/,
    /vkmobile\.me$/,
    /vkontakte\.com$/,
    /vkontakte\.ua$/,
    /com\.vkontakte\.android$/,
  ],
  wechat: [
    /wechat\.org$/,
    /w\.url\.cn$/,
    /wechat\.com$/,
    /com\.tencent\.mm$/,
  ],
  weibo: [
    /weibo\.com$/,
    /weibo\.cn$/,
    /com\.weico\.international$/,
    /com\.sina\.weibo$/,
  ],
  wikipedia: [
    /wikipedia\.org$/,
  ],
  whatsapp: [
    /whatsapp\.net$/,
    /whatsapp\.com$/,
    /whatsapp\.biz$/,
    /wa\.ma$/,
    /com\.whatsapp$/,
    /com\.whatsapp\.w4b$/,
  ],
  youtube: [
    /youtube\.com$/,
    /googlevideo\.com$/,
    /ytimg\.com$/,
    /youtube-ui\.l\.google\.com$/,
    /ytimg\.l\.google\.com$/,
    /ytstatic\.l\.google\.com$/,
    /youtubei\.googleapis\.com$/,
    /youtu\.be$/,
    /youtube-nocookie\.com$/,
    /youtube\.com$/,
    /gvt1\.com$/,
    /yt3\.ggpht\.com$/,
    /googleusercontent\.com$/,
    /com\.google\.android\.apps\.youtube\.kids$/,
    /com\.google\.android\.apps\.youtube\.music$/,
    /com\.google\.android\.apps\.youtube\.creator$/,
    /com\.google\.android\.apps\.youtube\.unplugged$/,
    /com\.google\.android\.youtube$/,
    /com\.google\.android\.youtube\.tvunplugged$/,
    /com\.google\.android\.youtube\.tvkids$/,
    /com\.google\.android\.youtube\.tv$/,
    /com\.google\.android\.youtube\.tvmusic$/,
    /com\.google\.android\.apps\.youtube\.music\.pwa$/,
    /com\.google\.android\.apps\.youtube\.vr$/,
    /youtube\.ae$/,
    /youtube\.at$/,
    /youtube\.az$/,
    /youtube\.ba$/,
    /youtube\.be$/,
    /youtube\.bg$/,
    /youtube\.bh$/,
    /youtube\.bo$/,
    /youtube\.by$/,
    /youtube\.ca$/,
    /youtube\.cat$/,
    /youtube\.ch$/,
    /youtube\.cl$/,
    /youtube\.co$/,
    /youtube\.co\.ae$/,
    /youtube\.co\.at$/,
    /youtube\.co\.cr$/,
    /youtube\.co\.hu$/,
    /youtube\.co\.id$/,
    /youtube\.co\.il$/,
    /youtube\.co\.in$/,
    /youtube\.co\.jp$/,
    /youtube\.co\.ke$/,
    /youtube\.co\.kr$/,
    /youtube\.co\.ma$/,
    /youtube\.co\.nz$/,
    /youtube\.co\.th$/,
    /youtube\.co\.tz$/,
    /youtube\.co\.ug$/,
    /youtube\.co\.uk$/,
    /youtube\.co\.ve$/,
    /youtube\.co\.za$/,
    /youtube\.co\.zw$/,
    /youtube\.com\.ar$/,
    /youtube\.com\.au$/,
    /youtube\.com\.az$/,
    /youtube\.com\.bd$/,
    /youtube\.com\.bh$/,
    /youtube\.com\.bo$/,
    /youtube\.com\.br$/,
    /youtube\.com\.by$/,
    /youtube\.com\.co$/,
    /youtube\.com\.do$/,
    /youtube\.com\.ec$/,
    /youtube\.com\.ee$/,
    /youtube\.com\.eg$/,
    /youtube\.com\.es$/,
    /youtube\.com\.gh$/,
    /youtube\.com\.gr$/,
    /youtube\.com\.gt$/,
    /youtube\.com\.hk$/,
    /youtube\.com\.hn$/,
    /youtube\.com\.hr$/,
    /youtube\.com\.jm$/,
    /youtube\.com\.jo$/,
    /youtube\.com\.kw$/,
    /youtube\.com\.lb$/,
    /youtube\.com\.lv$/,
    /youtube\.com\.ly$/,
    /youtube\.com\.mk$/,
    /youtube\.com\.mt$/,
    /youtube\.com\.mx$/,
    /youtube\.com\.my$/,
    /youtube\.com\.ng$/,
    /youtube\.com\.ni$/,
    /youtube\.com\.om$/,
    /youtube\.com\.pa$/,
    /youtube\.com\.pe$/,
    /youtube\.com\.ph$/,
    /youtube\.com\.pk$/,
    /youtube\.com\.pt$/,
    /youtube\.com\.py$/,
    /youtube\.com\.qa$/,
    /youtube\.com\.ro$/,
    /youtube\.com\.sa$/,
    /youtube\.com\.sg$/,
    /youtube\.com\.sv$/,
    /youtube\.com\.tn$/,
    /youtube\.com\.tr$/,
    /youtube\.com\.tw$/,
    /youtube\.com\.ua$/,
    /youtube\.com\.uy$/,
    /youtube\.com\.ve$/,
    /youtube\.cr$/,
    /youtube\.cz$/,
    /youtube\.de$/,
    /youtube\.dk$/,
    /youtube\.ee$/,
    /youtube\.es$/,
    /youtube\.fi$/,
    /youtube\.fr$/,
    /youtube\.ge$/,
    /youtube\.gr$/,
    /youtube\.gt$/,
    /youtube\.hk$/,
    /youtube\.hr$/,
    /youtube\.hu$/,
    /youtube\.ie$/,
    /youtube\.in$/,
    /youtube\.iq$/,
    /youtube\.is$/,
    /youtube\.it$/,
    /youtube\.jo$/,
    /youtube\.jp$/,
    /youtube\.kr$/,
    /youtube\.kz$/,
    /youtube\.lk$/,
    /youtube\.lt$/,
    /youtube\.lu$/,
    /youtube\.lv$/,
    /youtube\.ly$/,
    /youtube\.ma$/,
    /youtube\.me$/,
    /youtube\.mk$/,
    /youtube\.mx$/,
    /youtube\.my$/,
    /youtube\.net\.in$/,
    /youtube\.ng$/,
    /youtube\.ni$/,
    /youtube\.nl$/,
    /youtube\.no$/,
    /youtube\.pa$/,
    /youtube\.pe$/,
    /youtube\.ph$/,
    /youtube\.pk$/,
    /youtube\.pl$/,
    /youtube\.pr$/,
    /youtube\.pt$/,
    /youtube\.qa$/,
    /youtube\.ro$/,
    /youtube\.rs$/,
    /youtube\.ru$/,
    /youtube\.sa$/,
    /youtube\.se$/,
    /youtube\.sg$/,
    /youtube\.si$/,
    /youtube\.sk$/,
    /youtube\.sn$/,
    /youtube\.sv$/,
    /youtube\.tn$/,
    /youtube\.tv$/,
    /youtube\.ua$/,
    /youtube\.ug$/,
    /youtube\.uy$/,
    /youtube\.vn$/,
    /youtube\.voto$/,
  ],
}
